// Order lists (sidebar Order dropdown + routes, see components/DashboardSidebar/menuItems.js and
// App.js). `status` is sent as the `status` query param of GET orders (one status or a comma
// separated list) - the same values the storefront's order list uses.
// Stage pages (Purchasing, Tracking, ...) live in orderStages.js.
export const ORDER_BASE_PATH = "/dashboard/order";

// every status an order can have, in pipeline order (Order tab of tm-admin-web-react)
export const ORDER_STATUS_OPTIONS = [
  "Pending Payment",
  "Order Initiated",
  "Purchasing",
  "Purchase Completed",
  "Shipped From Supplier",
  "Received In China Warehouse",
  "On The Way To China Airport",
  "Received In China Airport",
  "On The Way To BD Airport",
  "Received In BD Airport",
  "On The Way To BD Warehouse",
  "Received In BD Warehouse",
  "Processing For Delivery",
  "On The Way To Delivery",
  "Completed",
  "Processing For Refund",
  "Refunded",
  "Cancelled",
];

export const statusTab = (status) => ({ label: status, value: status });


export const ORDER_STATUS_VIEWS = [
  // "All Orders" lists everything; the status select in the toolbar narrows it (statusFilter)
  { slug: "", title: "All Orders", status: "", statusFilter: ORDER_STATUS_OPTIONS },
  // Pending Payment: the only row action is Cancel Order (nothing is completed before it is paid)
  { slug: "pending-payment", title: "Pending Payment", status: "Pending Payment", actionSet: "pendingPayment" },
  { slug: "cancelled", title: "Cancelled", status: "Cancelled" },
].map((view) => ({
  actionSet: "order",
  ...view,
  path: view.slug ? `${ORDER_BASE_PATH}/${view.slug}` : ORDER_BASE_PATH,
}));
